import { Allocation } from '../generated/graphql'

export const getExperimentVariant = (experimentId: string, serverSideAllocation: any) => {
  return serverSideAllocation?.find((experiment: Allocation) => experiment?.experimentId === experimentId)?.variant
}
